import { defineStore } from "pinia"

export const useErrorStore = defineStore("error", {
  state: () => {
    return {
      showIntegrityErrorDialog: false,
      retryCallback: null as (() => void) | null
    }
  },
  actions: {
    showIntegrityError(retryCallback?: () => void) {
      this.showIntegrityErrorDialog = true
      this.retryCallback = retryCallback || null
    },
    hideIntegrityError() {
      this.showIntegrityErrorDialog = false
      this.retryCallback = null
    },
    retry() {
      if (this.retryCallback) {
        this.retryCallback()
      } else {
        // If no callback provided, just reload the page
        window.location.reload()
      }
      this.hideIntegrityError()
    }
  }
})
